<template>
  <div class="main main-tabbar">
    <TopCtrl />

    <template v-if="!easyUser">
      <!-- gmall用户订单 -->
      <Tabs>
        <TabPane label="未完成" name="orderOngoing">
          <ListView :on-infinite="onOrderOngoingLoadMore" :hasMore="orderOngoingHasMore">
            <OrderItem v-for="order in orderOngoing" :key="order.orderId" :order="order" />
            <template slot="load-done">
              <Nothing></Nothing>
            </template>
          </ListView>
          <EmptyListTip
            v-if="orderOngoingReady && orderOngoing.length <= 0"
            :icon="require('../../assets/icon-empty-cart.png')"
            text="无订单记录"
          />
        </TabPane>

        <TabPane label="已完成" name="orderDone">
          <ListView :on-infinite="onOrderDoneLoadMore" :hasMore="orderDoneHasMore">
            <OrderItem v-for="order in orderDone" :key="order.orderId" :order="order" />
            <template slot="load-done">
              <Nothing></Nothing>
            </template>
          </ListView>
          <EmptyListTip
            v-if="orderDoneReady && orderDone.length <= 0"
            :icon="require('../../assets/icon-empty-cart.png')"
            text="无订单记录"
          />
        </TabPane>
      </Tabs>
    </template>

    <template v-else>
      <!-- 大玩家用户订单 -->
      <ListView :on-infinite="easyOrderLoadMore" :hasMore="easyOrderHasMore">
        <OrderItem
          v-for="order in easyOrderList"
          :key="order.orderId"
          :order="order"
          @reload="reloadEasyOrder"
        />
        <template slot="load-done">
          <Nothing></Nothing>
        </template>
      </ListView>
      <EmptyListTip
        v-if="easyOrderReady && easyOrderList.length <= 0"
        :icon="require('../../assets/icon-empty-cart.png')"
        text="无订单记录"
      />
    </template>
  </div>
</template>

<script>
import api from "../../api";
import OrderItem from "@/components/orders/OrderItem";
import store from "../../api/store";

var Limit = 3;

export default {
  title: "订单列表",
  bodyClass: "gray-bg",
  keepAlive: true,
  components: { OrderItem },
  data() {
    return {
      easyUser: store.loginedUser.easyUser,
      unConfirmEasyOrderId: "",
      orderDoneReady: false,
      orderDoneLastId: "",
      orderDoneHasMore: true,
      orderDone: [
        // {
        //   orderId: 0,
        //   orderNo: '201813154613218',
        //   price: 12000,
        //   status: 1,
        //   product: {
        //     productId: 0,
        //     img: 'https://m.360buyimg.com/mobilecms/s750x750_jfs/t2644/302/3542165274/391846/c6df5587/57904959N117574a2.jpg',
        //     name: '雅鹿自由自在床褥床上用品泰国天然乳胶床垫床褥榻榻米床垫厚度 乳胶+椰棕复合床垫8cm加厚床褥 180*200cm',
        //     price: 12000,
        //     sale: 999,
        //     sku: {
        //       skuId: 0,
        //       name: '0.5m'
        //     }
        //   }
        // }
      ],
      orderOngoingReady: false,
      orderOngoingLastId: "",
      orderOngoingHasMore: true,
      orderOngoing: [
        // {
        //   orderId: 0,
        //   orderNo: '201813154613218',
        //   price: 12000,
        //   status: 0,
        //   product: {
        //     productId: 0,
        //     img: 'https://m.360buyimg.com/mobilecms/s750x750_jfs/t2644/302/3542165274/391846/c6df5587/57904959N117574a2.jpg',
        //     name: '雅鹿自由自在床褥床上用品泰国天然乳胶床垫床褥榻榻米床垫厚度 乳胶+椰棕复合床垫8cm加厚床褥 180*200cm',
        //     price: 12000,
        //     sale: 999,
        //     sku: {
        //       skuId: 0,
        //       name: '0.5m'
        //     }
        //   }
        // }
      ],
      easyOrderReady: false,
      easyOrderLastId: "",
      easyOrderHasMore: true,
      easyOrderList: []
    };
  },
  methods: {
    loadData() {
      this.$showLoading("加载中...");
      this.loadNotCompletedOrder(true);
      this.loadCompletedOrder(true);
    },
    loadNotCompletedOrder(isNew, doneCb) {
      if (!doneCb) {
        doneCb = () => {};
      }
      if (isNew) {
        this.orderOngoingReady = false;
        this.orderOngoing = [];
        this.orderOngoingHasMore = true;
      }

      api.order.getOrderList(
        0,
        this.orderOngoingLastId,
        Limit,
        res => {
          console.log(res);
          res.list.forEach(o => {
            var price = 0
            //TODO 插入响应sku数据
            var order = {
              orderId: o.id,
              orderNo: o.orderno,
              logistics: o.supplierName,
              logisticsOrderno: o.supplierOrderno,
              status: 0,
              time: o.payTime,
              completed: o.completed,
              skuType: o.skuType,
              virtualCardObsoleted: o.virtualCardObsoleted,
              products: []
            };

            o.orderItems.forEach(oi => {
              price += oi.totalPricePoint;
              order.products.push({
                productId: oi.id,
                img: oi.image,
                name: oi.title,
                price: oi.pricePoint,
                sale: 0,
                count: oi.count,
                sku: {
                  skuId: oi.skuId,
                  name: oi.specName
                }
              });
            });
            order['price'] = price
            this.orderOngoing.push(order);
          });

          this.orderOngoingHasMore = res.hasMore;
          this.orderOngoingLastId = res.lastId;
          this.orderOngoingReady = true;

          doneCb();
          this.$hideLoading();
        },
        r => {
          this.$alertDialog(r.msg);
          this.$hideLoading();
          doneCb();
        }
      );
    },
    loadCompletedOrder(isNew, doneCb) {
      if (!doneCb) {
        doneCb = () => {};
      }
      if (isNew) {
        this.orderDoneReady = false;
        this.orderDone = [];
        this.orderDoneHasMore = true;
      }

      api.order.getOrderList(
        1,
        this.orderDoneLastId,
        Limit,
        res => {
          console.log(res);
          res.list.forEach(o => {
            //TODO 插入响应sku数据
            var price = 0

            var order = {
              orderId: o.id,
              orderNo: o.orderno,
              price: 1000000,
              logistics: o.supplierName,
              logisticsOrderno: o.supplierOrderno,
              status: 1,
              time: o.payTime,
              virtualCardObsoleted: o.virtualCardObsoleted,
              products: []
            };

            o.orderItems.forEach(oi => {
              price += oi.totalPricePoint;

              order.products.push({
                productId: oi.id,
                img: oi.image,
                name: oi.title,
                price: oi.pricePoint,
                sale: 0,
                count: oi.count,
                sku: {
                  skuId: oi.skuId,
                  name: ""
                }
              });
            });
            order['price'] = price
            this.orderDone.push(order);
          });

          this.orderDoneHasMore = res.hasMore;
          this.orderDoneLastId = res.lastId;
          this.orderDoneReady = true;

          doneCb();
          this.$hideLoading();
        },
        r => {
          this.$alertDialog(r.msg);
          this.$hideLoading();
          doneCb();
        }
      );
    },
    onOrderOngoingLoadMore(done) {
      this.loadNotCompletedOrder(false, done);
    },
    onOrderDoneLoadMore(done) {
      this.loadCompletedOrder(false, done);
    },

    // 大玩家用户订单
    loadUnConfirmedOrder() {
      api.easy.easyOrderUnConfirmed(res => {
        // 先加载 未确认订单
        if (res.records) {
          //TODO 插入响应sku数据
          var o = res.records;
          this.unConfirmEasyOrderId = res.records.easyOrderId;
          var order = {
            comfirmCode: o.confirmCode,
            status: o.confirmStatus,
            createTime: o.createTime,
            deliveryStatus: o.deliveryStatus,
            easyOrderId: o.easyOrderId,
            expireTime: o.expireTime,
            expired: o.expired,
            finalPricePoint: o.finalPricePoint,
            operator: o.operator,
            orderNo: o.orderno,
            skuType: o.skuType,
            updateTime: o.updateTime,
            products: [],
            price: o.finalPricePoint,

          };

          o.orderItems.forEach(oi => {
            order.products.push({
              productId: oi.id,
              img: oi.image,
              name: oi.title,
              price: oi.pricePoint,
              sale: 0,
              count: oi.count,
              sku: {
                skuId: oi.skuId,
                name: oi.specName
              }
            });
          });
          this.easyOrderList.push(order);
          
        }

        // 请求完未确认订单，请求所有订单
        this.easyOrderLoadMore();
      });
    },
    easyOrderLoadMore(done) {
      this.loadEasyOrder(false, done);
    },
    loadEasyOrder(isNew, doneCb) {
      if (!doneCb) {
        doneCb = () => {};
      }
      if (isNew) {
        this.easyOrderReady = false;
        this.easyOrderList = [];
        this.easyOrderHasMore = true;
      }
      api.easy.easyOrderHistorical(
        this.easyOrderLastId,
        Limit,
        this.unConfirmEasyOrderId,
        res => {
          console.log(res);
          if (res.records) {
            res.records.forEach(o => {
              console.log(o);
              var order = {
                comfirmCode: o.confirmCode,
                status: o.confirmStatus,
                createTime: o.createTime,
                deliveryStatus: o.deliveryStatus,
                easyOrderId: o.easyOrderId,
                expireTime: o.expireTime,
                expired: o.expired,
                finalPricePoint: o.finalPricePoint,
                operator: o.operator,
                orderNo: o.orderno,
                skuType: o.skuType,
                updateTime: o.updateTime,
                products: [],
                price: o.finalPricePoint,

              };

              o.orderItems.forEach(oi => {
                order.products.push({
                  productId: oi.id,
                  img: oi.image,
                  name: oi.title,
                  price: oi.pricePoint,
                  sale: 0,
                  count: oi.count,
                  sku: {
                    skuId: oi.skuId,
                    name: oi.specName
                  }
                });
              });
              this.easyOrderList.push(order);
            });
          }

          this.easyOrderHasMore = res.hasMore;
          this.easyOrderLastId = res.lastId;
          this.easyOrderReady = true;
          doneCb();
        }
      );
    },
    reloadEasyOrder() {
      this.easyOrderLastId = "";
      this.unConfirmEasyOrderId = "";
      this.easyOrderReady = false;
      this.easyOrderList = [];
      this.easyOrderHasMore = true;
      this.easyOrderLoadMore();
    }
  },
  mounted() {
    //恢复

    if (this.easyUser) {
      // 大玩家用户 执行大玩家的请求
      this.loadUnConfirmedOrder();
    } else {
      // 正常gmall订单请求
      api.pagestate.recover(this, () => {
        console.log("init data");
        this.loadData();
      });
    }
  }
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/orders/List.vue